import { gql } from '@apollo/client'
import { StarLiteFragment } from '@src/graphql/fragment/star'

export default gql`
  query GetStarByIDs($starIDs: [String!]!, $length: Int) {
    getStars(
      filterInput: { starID: $starIDs }
      sortInput: { sortBy: IDAsc }
      pagingInput: { first: $length }
    ) {
      edges {
        node {
          ...StarLite
        }
      }
    }
  }

  ${StarLiteFragment}
`
